import { takeLatest, put, call, fork } from 'redux-saga/effects';
import callApi from 'utils/api';
import { getUrlParameters } from 'utils/helpers';
import * as actionTypes from './constants';

import { fetchNavigationalInfoSuccess, fetchNavigationalInfoFailure } from './navigation-actions';

export function* fetchNavigationalInfo(action) {
  try {
    const { type, id, context, technician } = action.payload;
    const urlParams = {
      context: context && context !== id ? context : null,
      technician,
    };
    const results = yield call(callApi, {
      endpoint: `details/${type}/${id}?${getUrlParameters({ params: urlParams })}`,
      options: {
        errorMessage: `Could not get details data for ${type}: ${id}`,
        retryAction: action,
      },
    });
    yield put(fetchNavigationalInfoSuccess(results));
  } catch (err) {
    yield put(fetchNavigationalInfoFailure(err));
  }
}

function* watchFetchNavigationalInfo() {
  yield takeLatest(actionTypes.NAVIGATION_DETAILS_REQUEST, fetchNavigationalInfo);
}

export default [fork(watchFetchNavigationalInfo)];
